import { useEffect, useState, useCallback } from 'react';
import { reservationService } from '../services/reservationService';
import { PagedReservationResponseDto, ReservationResponseDto } from '../types/reservation';

export const useReservations = (initialPage = 1, initialLimit = 10) => {
  const [data, setData] = useState<ReservationResponseDto[]>([]);
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<string | undefined>(undefined);

  const fetchReservations = useCallback(async (p = page, l = limit, status?: string) => {
    setLoading(true);
    setError(null);
    try {
      const res: PagedReservationResponseDto = await reservationService.getMyReservations(p, l, status);
      setData(res.data || []);
      setTotal(res.total || 0);
      setPage(res.page || p);
      setLimit(res.limit || l);
    } catch (err: unknown) {
      console.error('Error fetching reservations', err);
      let message: string | null = null;
      if (err && typeof err === 'object' && 'message' in err) {
        const e = err as Record<string, unknown>;
        if (typeof e.message === 'string') message = e.message;
      }
      setError(message || 'Error al obtener reservas');
    } finally {
      setLoading(false);
    }
  }, [page, limit]);

  useEffect(() => {
    fetchReservations(page, limit, statusFilter);
  }, [fetchReservations, page, limit, statusFilter]);
  
  return {
    data,
    page,
    limit,
    total,
    loading,
    error,
    fetchReservations,
    setPage,
    setLimit,
    statusFilter,
    setStatusFilter,
  };
};
